export default __webpack_public_path__ + "static/media/downloadAshreyaWeb.28f2b582.svg";